import { Separator as BaseSeparator } from '@base-ui/react/separator'
import { cx } from '../cx'
import styles from './Separator.module.css'

/** A horizontal hairline between two parts of a page; Base UI's `role="separator"`. */
export function Separator({ className }: { className?: string }) {
  return <BaseSeparator className={cx(styles.separator, className)} />
}
